import React from 'react';
import './ScreenHeader.css';

interface ScreenHeaderProps {
  title: string;
  subtitle?: string;
}

export const ScreenHeader: React.FC<ScreenHeaderProps> = ({ title, subtitle }) => {
  return (
    <div className="screen-header">
      <h1 className="screen-header__title">{title}</h1>
      {subtitle && <p className="screen-header__subtitle">{subtitle}</p>}
    </div>
  );
};
